import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api.ts';

export function MyHome() {
  const me = useQuery({ queryKey: ['me'], queryFn: () => api.me() });
  const boats = useQuery({ queryKey: ['my-boats'], queryFn: () => api.myBoats() });
  const entries = useQuery({ queryKey: ['my-entries'], queryFn: () => api.myEntries() });

  const upcoming = (entries.data ?? []).filter(
    (e) => e.raceStatus !== 'finished' && e.raceStatus !== 'cancelled',
  );

  return (
    <div className="space-y-5">
      <header>
        <h1 className="text-xl font-bold">
          Hei {me.data?.fullName || me.data?.username} 👋
        </h1>
        <p className="text-sm text-slate-400">Her kan du forvalte dine båter og påmeldinger.</p>
      </header>

      <section className="bg-slate-900/40 border border-slate-800 rounded-xl p-4">
        <div className="flex items-center justify-between mb-2">
          <h2 className="font-semibold">Mine båter</h2>
          <Link to="/admin/min-side/baater" className="text-xs text-sky-400">
            Forvalt →
          </Link>
        </div>
        {boats.isLoading ? (
          <p className="text-slate-500 text-sm">Laster…</p>
        ) : boats.data && boats.data.length > 0 ? (
          <ul className="space-y-1 text-sm">
            {boats.data.map((b) => (
              <li key={b.id} className="flex items-center gap-3">
                <span className="font-mono text-xs text-slate-400 w-16">{b.sailNumber}</span>
                <span className="flex-1">{b.boatName}</span>
                {b.className && (
                  <span className="text-xs bg-slate-700/40 text-slate-300 px-2 py-0.5 rounded">
                    {b.className}
                  </span>
                )}
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-sm text-slate-500">
            Du har ingen båter ennå.{' '}
            <Link to="/admin/min-side/baater" className="text-sky-400">
              Legg til en
            </Link>
            .
          </p>
        )}
      </section>

      <section className="bg-slate-900/40 border border-slate-800 rounded-xl p-4">
        <div className="flex items-center justify-between mb-2">
          <h2 className="font-semibold">Kommende påmeldinger</h2>
          <Link to="/admin/min-side/regattaer" className="text-xs text-sky-400">
            Se alle regattaer →
          </Link>
        </div>
        {entries.isLoading ? (
          <p className="text-slate-500 text-sm">Laster…</p>
        ) : upcoming.length > 0 ? (
          <ul className="divide-y divide-slate-800">
            {upcoming.map((e) => (
              <li key={e.id} className="py-2 flex items-center gap-3">
                <div className="flex-1 min-w-0">
                  <div className="font-semibold truncate">{e.raceName}</div>
                  <div className="text-xs text-slate-400">
                    {new Date(e.raceStartTime).toLocaleString('no-NO', {
                      dateStyle: 'short',
                      timeStyle: 'short',
                      timeZone: 'Europe/Oslo',
                    })}{' '}
                    • {e.sailNumber} {e.boatName}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-sm text-slate-500">Ingen kommende påmeldinger.</p>
        )}
      </section>
    </div>
  );
}
